import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { NextPage } from 'next';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Layout from '~/src/features/_layout';
import Showcase from '~/src/features/showcase';
import { unauthorizedShowcaseEnabled } from '~/src/features/showcase/constants/unauthorizedAbnVariants';
import { initialProps } from '~/src/helpers/basePageFunc';
import { nonPermanentRedirect } from '~/src/helpers/url';
import { TState } from '~/src/store';
import { getHostname, selectCompanyName } from '~/src/store/selectors/city';

const SubscriptionsPage: NextPage = () => {
    const { hostname, companyName, currentCity } = useSelector((state: TState) => ({
        hostname: getHostname(state),
        companyName: selectCompanyName(state),
        currentCity: state.city.currentCity,
    }), shallowEqual);

    return (
        <Layout
            title={`Интернет-провайдер ${companyName} в ${currentCity.cityIn}`}
            description={`Официальный сайт провайдера ${companyName} в ${currentCity.cityIn}. Подключить быстрый Интернет, Цифровое телевидение и онлайн-кинотеатр, Домофон и Видеонаблюдение. Адреса и телефоны офисов.`}
            relCanonical={`https://${hostname}/`}
            withMenu={true}
            withFooter={true}
            withChat={true}
            bgColor={COLORS.BgMain}
        >
            <Showcase/>
        </Layout>
    );
};

SubscriptionsPage.getInitialProps = async(options) => {
    const { res } = options;
    const { validatedAccessToken } = await initialProps(options);


    if (!unauthorizedShowcaseEnabled() && !validatedAccessToken) {
        nonPermanentRedirect({ res, location: '/' });
    }

    return {};
};

export default SubscriptionsPage;
